import React from 'react';
import './DeleteAccount.css';
import Navbar from './Navbar';
import Footer from './Footer';

const DeleteAccount = () => {
  return (
    <div className="delete-account-page">
      <Navbar />
      <div className="delete-account-container">
        <div className="delete-account-content">
          <div className="delete-account-icon">
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="#ef4444"/>
            </svg>
          </div>
          <h1>Supprimer votre compte</h1>
          <p className="subtitle">
            Vous pouvez supprimer votre compte Joby et toutes vos données associées
          </p>

          <div className="info-box warning">
            <h3>⚠️ Attention</h3>
            <p>
              La suppression de votre compte est <strong>permanente et irréversible</strong>. 
              Cette action supprimera :
            </p>
            <ul>
              <li>Votre compte et profil utilisateur</li>
              <li>Toutes vos candidatures d'emploi</li>
              <li>Vos emplois sauvegardés</li>
              <li>Votre CV et photo de profil</li>
              <li>Toutes vos données personnelles</li>
            </ul>
          </div>

          <div className="info-box">
            <h3>Comment supprimer votre compte</h3>
            <div className="method">
              <h4>📱 Méthode 1 : Depuis l'application mobile</h4>
              <ol>
                <li>Ouvrez l'application Joby</li>
                <li>Allez dans votre profil</li>
                <li>Cliquez sur "Paramètres"</li>
                <li>Allez dans "Privacy & Security"</li>
                <li>Cliquez sur "Delete Account"</li>
                <li>Confirmez la suppression</li>
              </ol>
            </div>

            <div className="method">
              <h4>📧 Méthode 2 : Par email</h4>
              <p>
                Envoyez un email à <a href="mailto:privacy@joby.live">privacy@joby.live</a> avec :
              </p>
              <ul>
                <li>Votre adresse email de compte</li>
                <li>Le sujet : "Demande de suppression de compte"</li>
                <li>Votre demande de suppression</li>
              </ul>
              <p>
                Nous traiterons votre demande dans les <strong>5 jours ouvrables</strong>.
              </p>
            </div>
          </div>

          <div className="contact-box">
            <h3>Besoin d'aide ?</h3>
            <p>
              Si vous avez des questions concernant la suppression de votre compte ou si vous rencontrez des problèmes, 
              contactez-nous :
            </p>
            <ul>
              <li><strong>Email :</strong> <a href="mailto:privacy@joby.live">privacy@joby.live</a></li>
              <li><strong>Site web :</strong> <a href="https://joby.live">https://joby.live</a></li>
            </ul>
          </div>

          <div className="back-link">
            <a href="/">← Retour à l'accueil</a>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default DeleteAccount;

